"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomText = void 0;
const Link_1 = __importDefault(require("root/src/client/web/base/Link"));
function BottomText() {
    return <span className="text-center">For more help, join us in <DiscordLink />!</span>;
}
exports.BottomText = BottomText;
function DiscordLink() {
    return <Link_1.default href="https://discord.gg/x9ABQ8qcjS ">Discord</Link_1.default>;
}
